import { render } from "./EditDelivery.vue?vue&type=template&id=3a857967&scoped=true"
import script from "./EditDelivery.vue?vue&type=script&lang=js"
export * from "./EditDelivery.vue?vue&type=script&lang=js"

import "./EditDelivery.vue?vue&type=style&index=0&id=3a857967&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a857967"]])

export default __exports__